import { ChangeDetectorRef, Component, ElementRef, Injectable, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { AutenticacionService } from '../../services/autenticacion.service';
import { TodoItemFlatNode, TodoItemNode } from 'src/app/models/generic/Maestro_Grupos_Menu';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { CollectionViewer, SelectionChange, SelectionModel } from '@angular/cdk/collections';
import { SubirArchivosUsuarioService } from '../../services/subirarchivosusuario';
import { SubirArchivos_Usuario, SubirArchivos_Usuario_Archivos, SubirArchivos_Usuario_Archivos_Seleccionados, SubirArchivos_Usuario_Directorios } from '../../models/generic/SubirArchivos_Usuario';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'subirarchivosusuario',
  templateUrl: './subirarchivosusuario.component.html',
  styleUrls: ['./subirarchivosusuario.component.scss']
})
export class SubirArchivosUsuarioComponent implements OnInit{
  
  form: FormGroup;
  formCambiarDirectorio: FormGroup;
  formData = new FormData();
  mostrarCargando: boolean = false;
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('uploadFile', {static: false}) _uploadFile: ElementRef;
  @ViewChild('modalcreardirectorio', {static: false}) _ModalCrearDirectorio: TemplateRef<any>;
  ListaArchivos: SubirArchivos_Usuario_Archivos[] = [];
  ListaArchivosSeleccionados: SubirArchivos_Usuario_Archivos[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSourceArchivos: MatTableDataSource<SubirArchivos_Usuario_Archivos>;
  columnasEncabezado: string[] = ['select', 'nombreArchivo', 'fecha'];
  Checkeados = new SelectionModel<any>(true, []);
  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();
  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();
  selectedParent: TodoItemFlatNode | null = null;
  treeControl: FlatTreeControl<TodoItemFlatNode>;
  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;
  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;
  itemSeleccionado: SubirArchivos_Usuario = new SubirArchivos_Usuario();
  itemSeleccionadoDirectorio: SubirArchivos_Usuario_Directorios = new SubirArchivos_Usuario_Directorios();
  idSeleccionado: string = '';
  idFiltroSeleccionado: number = 0;
  rutaDirectorioConsulta: string = '';
  rutaDirectorioEliminarLista: string = '';
  idItemDirectorio: number = 0;
  descripcionRutaSeleccionada: string = '';
  recargarCarpetaPrincipal: boolean = true;
  listaAsignarData: TodoItemNode[] = [];
  getLevel = (node: TodoItemFlatNode) => node.level;
  isExpandable = (node: TodoItemFlatNode) => node.expandable;
  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;
  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;
  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.item === '';
  transformer = (node: TodoItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.item === node.item
        ? existingNode
        : new TodoItemFlatNode();
    flatNode.id = node.id;
    flatNode.item = node.item;
    flatNode.idFilter = node.idFilter;
    flatNode.idParent = node.idParent;
    flatNode.level = level;
    if (this.utilitariosService.VerificarContieneDatosLista(node.children)) {
      flatNode.expandable = true;  
    } else {
      flatNode.expandable = false;
    }
    
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  }
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: SubirArchivosUsuarioService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService,
    public modal: MatDialog) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.ConsultarDirectorios();

    this.menuService.NotificarAccionBotonPrincipal.subscribe((accion: string) => {
      if (accion === 'check') {
        this.GuardarRegistro();
      }
    });
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      directorio: ['', [Validators.required, Validators.maxLength(100)]]
    });

    this.formCambiarDirectorio = this.fb.group({
      directorioPrincipal: [0]
    });
  }

  EstaSeleccionado(idRegistro: string): boolean {
    if (this.idSeleccionado === idRegistro) {
      return true;
    }
    return false;
  }

  CambiarSeleccionRegistro(idRegistro: string, idFiltro: number): void {
    if (this.utilitariosService.VerificarContieneDatosTexto(idRegistro)) {
      if (this.utilitariosService.VerificarContieneDatosNumerico(idFiltro)) {
        if (this.datosServices.ListaDirectorios.filter(x => x.id === idFiltro).length > 0) {
          this.itemSeleccionado = this.datosServices.ListaDirectorios.filter(x => x.id === idFiltro)[0];
        }
      }
      
      this.itemSeleccionadoDirectorio = this.itemSeleccionado.listaDirectorios.filter(x => x.ruta === idRegistro)[0];
      this.idSeleccionado = idRegistro;
      this.idFiltroSeleccionado = idFiltro;
      this.descripcionRutaSeleccionada = this.itemSeleccionadoDirectorio.descripcionRuta;
      this.ConsultarArchivos();
      this.ExpanderCarpetasSeleccionadas(idRegistro);
    }
  }

  BuscarCarpetaPrincipal(nombreArchivo: string): void {
    let filtroCompleto = this.itemSeleccionado.listaDirectorios.filter(x => x.rutaPadre === this.itemSeleccionadoDirectorio.ruta && x.descripcion === nombreArchivo);
    if (filtroCompleto.length > 0) {
      this.CambiarSeleccionRegistro(filtroCompleto[0].ruta, this.itemSeleccionado.id);
    }
  }

  ExpanderCarpetasSeleccionadas(rutaSeleccionada: string) {
    if (this.utilitariosService.VerificarContieneDatos(this.treeControl)) {
      if (this.utilitariosService.VerificarContieneDatos(this.treeControl.dataNodes)) {
        if (this.treeControl.dataNodes.length > 0) {
          this.treeControl.collapseAll();
          this.treeControl.expand(this.treeControl.dataNodes[0]);
          let listaComponentesAbrir: TodoItemFlatNode[] = [];
          this.EncontrarRutasCompletas(listaComponentesAbrir, rutaSeleccionada);
          for (let index = 0; index < listaComponentesAbrir.length; index++) {
            let item = listaComponentesAbrir[index];
            this.treeControl.expand(item);
          }
        }
      }
    }    
  }

  EncontrarRutasCompletas(listaComponentesAbrir: TodoItemFlatNode[], rutaBuscar: string) {
    for (let index = 0; index < this.treeControl.dataNodes.length; index++) {
      let item = this.treeControl.dataNodes[index];
      if (item.id === rutaBuscar) {
        listaComponentesAbrir.push(item);
        if (item.idParent !== '') {
          this.EncontrarRutasCompletas(listaComponentesAbrir, item.idParent);
        }
      }
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  GuardarRegistro() {
    if (this.form.valid) {
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      this.mostrarCargando = true;
      let itemSeleccionado: SubirArchivos_Usuario_Archivos_Seleccionados = new SubirArchivos_Usuario_Archivos_Seleccionados();
      itemSeleccionado.itemDirectorio = this.itemSeleccionadoDirectorio;
      itemSeleccionado.listaArchivos = this.Checkeados.selected;
      this.datosServices.EliminarArchivos(itemSeleccionado)
              .subscribe((resp: RespuestaGenerica) =>{
                this.mostrarCargando = false;
                if (resp.procesoExitoso == false) {
                  this.utilitariosService.MensajeToast(resp.mensaje);
                } else {
                  let directoriosEliminar = itemSeleccionado.listaArchivos.filter(x => x.esDirectorio);
                  for (let indexEliminar = 0; indexEliminar < directoriosEliminar.length; indexEliminar++) {
                    let itemEliminar = directoriosEliminar[indexEliminar];
                    let rutaCompleta = `${this.itemSeleccionadoDirectorio.ruta}\\${itemEliminar.nombreArchivo}`;
                    
                    for (let index = 0; index < this.datosServices.ListaDirectorios.length; index++) {
                      let item = this.datosServices.ListaDirectorios[index];
                      item.listaDirectorios = item.listaDirectorios.filter(x => x.ruta !== rutaCompleta);
                    }

                    this.treeControl.dataNodes = this.treeControl.dataNodes.filter(x => x.id !== rutaCompleta);
                    this.EliminarItemDataSource(rutaCompleta);
                  }
                  
                  this.recargarTreeView(this.listaAsignarData);
                  this.CambiarSeleccionRegistro(this.idSeleccionado, this.idFiltroSeleccionado);
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
    }
  }
  EliminarItemDataSource(ruta: string) {
    for (let index = 0; index < this.listaAsignarData.length; index++) {
      let itemData = this.listaAsignarData[index];
      this.EliminarItemDataSourceDetalle(ruta, itemData);
    }
  }
  EliminarItemDataSourceDetalle(ruta: string, itemDataBuscar: TodoItemNode) {
    if (itemDataBuscar.children.filter(x => x.id === ruta).length > 0) {
      itemDataBuscar.children = itemDataBuscar.children.filter(x => x.id !== ruta);
    } else {
      for (let index = 0; index < itemDataBuscar.children.length; index++) {
        let itemData = itemDataBuscar.children[index];
        this.EliminarItemDataSourceDetalle(ruta, itemData);
      }
    }
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }
  ConsultarDirectorios() {
    this.mostrarCargando = true;
    let parametroConsulta = this.fb.group({
      filtro: ['']
    });
    this.datosServices.Consultar(parametroConsulta.value)
            .subscribe((resp: SubirArchivos_Usuario[]) =>{
              this.datosServices.ListaDirectorios = resp;

              if (this.datosServices.ListaDirectorios.length > 0) {
                this.CambiarDirectorioPrincipal(this.datosServices.ListaDirectorios[0].id, '');
              } else {
                this.mostrarCargando = false;
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarSubDirectorios(directorioConsulta: string, directorioEliminarLista: string, idItemDirectorio: number) {
    this.rutaDirectorioConsulta = directorioConsulta;
    this.rutaDirectorioEliminarLista = directorioEliminarLista;
    this.idItemDirectorio = idItemDirectorio;

    let parametroConsulta = this.fb.group({
      ruta: ['']
    });
    parametroConsulta.get('ruta').setValue(directorioConsulta);

    this.datosServices.ConsultarSubDirectorio(parametroConsulta.value)
            .subscribe((resp: SubirArchivos_Usuario_Directorios[]) =>{
              let itemDirectorioActualizar = this.datosServices.ListaDirectorios.filter(x => x.id == idItemDirectorio)[0];
              itemDirectorioActualizar.listaDirectorios = itemDirectorioActualizar.listaDirectorios.filter(x => x.ruta !== directorioEliminarLista);

              for (let index = 0; index < resp.length; index++) {
                if (itemDirectorioActualizar.listaDirectorios.filter(x => x.ruta === resp[index].ruta).length === 0) {
                  itemDirectorioActualizar.listaDirectorios.push(resp[index]);
                }
              }
          
              this.EstablecerHijos_Padre(directorioConsulta, itemDirectorioActualizar);
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  CambiarDirectorioPrincipal(id: number, directorioPosicionar: string = '') {
    this.itemSeleccionadoDirectorio = null;
    this.idSeleccionado = '';
    this.descripcionRutaSeleccionada = '';
    this.ListaArchivos = [];
    this.recargarLista();

    this.itemSeleccionado = this.datosServices.ListaDirectorios.filter(x => x.id === id)[0];
    this.EstablecerValoresTreeView();
    
    if (this.utilitariosService.VerificarContieneDatosTexto(directorioPosicionar)) {
      this.CambiarSeleccionRegistro(directorioPosicionar, id);
    } else {
      if (this.itemSeleccionado.listaDirectorios.length > 0) {
        this.CambiarSeleccionRegistro(this.itemSeleccionado.listaDirectorios[0].ruta, id);
      } else {
        this.mostrarCargando = false;
      }
    }
  }
  ConsultarArchivos() {
    this.mostrarCargando = true;
    if (this.utilitariosService.VerificarContieneDatos(this.itemSeleccionadoDirectorio)) {
      let parametroConsulta = this.fb.group({
        ruta: [this.itemSeleccionadoDirectorio.ruta]
        ,subdirectorios: [this.itemSeleccionado.subdirectorios]
      });
      this.datosServices.ConsultarArchivos(parametroConsulta.value)
              .subscribe((resp: SubirArchivos_Usuario_Archivos[]) =>{
                this.ListaArchivos = resp;
                this.recargarLista();
                this.mostrarCargando = false;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
    }
  }
  recargarLista() {
    this.dataSourceArchivos = new MatTableDataSource(this.ListaArchivos);
    this.dataSourceArchivos.paginator = this.paginator;
    this.dataSourceArchivos.sort = this.sort;
    this.Checkeados.clear();
  }
  recargarTreeView(listaAsignar: TodoItemNode[]) {
    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSource.data = listaAsignar;
    this.listaAsignarData = listaAsignar;
  }
  EstablecerTreeControl(listaAsignar: TodoItemNode[]) {
    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSource.data = listaAsignar;
    this.listaAsignarData = listaAsignar;

    this.treeControl.expansionModel.changed.subscribe(change => {
      if (this.utilitariosService.VerificarContieneDatos(change)) {
        if (this.utilitariosService.VerificarContieneDatos(change.added)) {
          if (this.utilitariosService.VerificarContieneDatos(change.added[0])) {
            let listaPrincipalFiltrada = this.datosServices.ListaDirectorios.filter(x => x.id == change.added[0].idFilter);
            if (this.utilitariosService.VerificarContieneDatosLista(listaPrincipalFiltrada)) {
              let itemDirectorioParcial = listaPrincipalFiltrada[0].listaDirectorios.filter( x => x.ruta === `${change.added[0].id}_parcial`);
              if (this.utilitariosService.VerificarContieneDatosLista(itemDirectorioParcial)) {
                this.ConsultarSubDirectorios(itemDirectorioParcial[0].rutaPadre, itemDirectorioParcial[0].ruta, listaPrincipalFiltrada[0].id);
              }
            }
          }
        }
      }
    });
  }
  EstablecerValoresTreeView() {
    let listaDatosSeleccionar: TodoItemNode[] = [];

    let itemTreeView: TodoItemNode = new TodoItemNode();
    itemTreeView.id = '';
    itemTreeView.item = 'Repositorio';
    itemTreeView.icon = '';
    itemTreeView.idParent = '';
    itemTreeView.idFilter = 0;
    itemTreeView.children = [];
    this.EstablecerValoresTreeViewPadres(itemTreeView);
    listaDatosSeleccionar.push(itemTreeView);

    this.EstablecerTreeControl(listaDatosSeleccionar);
  }
  EstablecerValoresTreeViewPadres(itemTreeViewPadre: TodoItemNode) {
    if (this.utilitariosService.VerificarContieneDatos(this.datosServices.ListaDirectorios)) {
      for (let index = 0; index < this.datosServices.ListaDirectorios.length; index++) {
        let item = this.datosServices.ListaDirectorios[index];
        if (this.utilitariosService.VerificarContieneDatos(item.listaDirectorios)) {
          let listaDirectoriosPadre = item.listaDirectorios.filter(x => x.rutaPadre === '');
          for (let index = 0; index < listaDirectoriosPadre.length; index++) {
            let directorio = listaDirectoriosPadre[index];
            let itemTreeView: TodoItemNode = new TodoItemNode();
            itemTreeView.id = directorio.ruta;
            itemTreeView.item = directorio.descripcion;
            itemTreeView.icon = 'folder';
            itemTreeView.idParent = directorio.rutaPadre;
            itemTreeView.idFilter = item.id;
            itemTreeView.children = [];
            this.EstablecerValoresTreeViewHijos(item, directorio.ruta, itemTreeView);
            itemTreeViewPadre.children.push(itemTreeView);
          }
        }
      }  
    }
  }
  EstablecerValoresTreeViewHijos(itemDirectorioBusqueda: SubirArchivos_Usuario, id: string, itemTreeView: TodoItemNode) {
    for (let index = 0; index < itemDirectorioBusqueda.listaDirectorios.length; index++) {
      if (itemDirectorioBusqueda.listaDirectorios[index].rutaPadre.toString() === id) {
        let itemTreeViewChild: TodoItemNode = new TodoItemNode();
        itemTreeViewChild.id = itemDirectorioBusqueda.listaDirectorios[index].ruta;
        itemTreeViewChild.item = itemDirectorioBusqueda.listaDirectorios[index].descripcion;
        itemTreeViewChild.icon = 'folder';
        itemTreeViewChild.idParent = itemDirectorioBusqueda.listaDirectorios[index].rutaPadre;
        itemTreeViewChild.idFilter = itemDirectorioBusqueda.id;
        itemTreeViewChild.children = [];
        this.EstablecerValoresTreeViewHijos(itemDirectorioBusqueda, itemDirectorioBusqueda.listaDirectorios[index].ruta, itemTreeViewChild);
        itemTreeView.children.push(itemTreeViewChild);
      }
    }
  }
  EstablecerHijos_Padre(idRutaBuscar: string, itemDirectorioBusqueda: SubirArchivos_Usuario) {
    let listaDatosSeleccionar: TodoItemNode[] = [];
    for (let index = 0; index < this.dataSource.data.length; index++) {
      listaDatosSeleccionar.push(this.dataSource.data[index]);
    }

    let seguirBuscando: boolean = true;

    for (let index = 0; index < listaDatosSeleccionar.length; index++) {
      if (seguirBuscando) {
        let itemValidar = listaDatosSeleccionar[index];
        if (itemValidar.id === idRutaBuscar) {
          itemValidar.children = [];
          this.EstablecerValoresTreeViewHijos(itemDirectorioBusqueda, itemValidar.id, itemValidar);

          seguirBuscando = false;
        } else {
          this.BuscarRuta_EstablecerHijos_Padre(idRutaBuscar, itemValidar, itemDirectorioBusqueda);
        } 
      }
    }

    this.EstablecerTreeControl(listaDatosSeleccionar);
    this.ExpanderCarpetasSeleccionadas(idRutaBuscar);
  }
  BuscarRuta_EstablecerHijos_Padre(idRutaBuscar: string, itemNodoBusqueda: TodoItemNode, itemDirectorioBusqueda: SubirArchivos_Usuario) {
    let seguirBuscando: boolean = true;

    if (seguirBuscando) {
      if (this.utilitariosService.VerificarContieneDatosLista(itemNodoBusqueda.children)) {
        for (let index = 0; index < itemNodoBusqueda.children.length; index++) {
          let itemValidar = itemNodoBusqueda.children[index];
          if (itemValidar.id === idRutaBuscar) {
            itemValidar.children = [];
            this.EstablecerValoresTreeViewHijos(itemDirectorioBusqueda, itemValidar.id, itemValidar);
  
            seguirBuscando = false;
          } else {
            this.BuscarRuta_EstablecerHijos_Padre(idRutaBuscar, itemValidar, itemDirectorioBusqueda);
          }
        }
      }
    }
  }
  TieneSeleccionado(): boolean {
    if (this.utilitariosService.VerificarContieneDatos(this.form)) {
      if (this.form.get('id').value > 0) {
        return true;
      }
    }
    return false;
  }
  EstaSeleccionadoArchivo(itemSeleccionado: SubirArchivos_Usuario_Archivos) {
    return this.ListaArchivosSeleccionados.filter(x => x.esDirectorio === itemSeleccionado.esDirectorio && x.nombreArchivo === itemSeleccionado.nombreArchivo).length > 0;
  }
  CambiarSeleccionArchivo(itemSeleccionado: SubirArchivos_Usuario_Archivos, seleccionado: any): void {
    if (seleccionado.checked) {
      if (this.ListaArchivosSeleccionados.filter(x => x.esDirectorio === itemSeleccionado.esDirectorio && x.nombreArchivo === itemSeleccionado.nombreArchivo).length === 0) {
        this.ListaArchivosSeleccionados.push(itemSeleccionado);
      }
    } else {
      if (this.ListaArchivosSeleccionados.filter(x => x.esDirectorio === itemSeleccionado.esDirectorio && x.nombreArchivo === itemSeleccionado.nombreArchivo).length > 0) {
        this.ListaArchivosSeleccionados = [];
        for (let index = 0; index < this.ListaArchivos.length; index++) {
          if (this.ListaArchivos[index].esDirectorio !== itemSeleccionado.esDirectorio
              && this.ListaArchivos[index].nombreArchivo !== itemSeleccionado.nombreArchivo) {
            this.ListaArchivosSeleccionados.push(this.ListaArchivos[index]);
          }
        }
      }
    }
  }
  ArchivoSeleccionar(_Archivos: File[]) {
    let cantidadArchivos: number = _Archivos.length;
    for (let index = 0; index < cantidadArchivos; index++) {
      this.formData = new FormData();
      this.formData.append('formFiles', _Archivos[index]);
      // Array.from(_Archivos).forEach(f => this.formData.append('formFiles', f));
      let parametroConsulta = this.fb.group({
        ruta: [this.itemSeleccionadoDirectorio.ruta]
      });
  
      this.mostrarCargando = true;
      this.datosServices.ImportarArchivos(this.formData, parametroConsulta.value)
        .subscribe((resp: RespuestaGenerica) => {
          if ((index + 1) === _Archivos.length) {
            this.ConsultarArchivos();
          }
        },
        (error: Error) => {
          this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
          this.mostrarCargando = false;
          this.cd.detectChanges();
        },
        () => this.cd.detectChanges());
    }
  }
  AbrirCargarArchivo() {
    if (this.utilitariosService.VerificarContieneDatosTexto(this.idSeleccionado)) {
      this._uploadFile.nativeElement.value = '';
      this._uploadFile.nativeElement.click();
    } else {
      this.utilitariosService.MensajeToast('Debe seleccionar una carpeta.');
    }
  }
  CrearCarpeta() {
    if (this.utilitariosService.VerificarContieneDatosTexto(this.idSeleccionado)) {
      this.IniciarFormulario();
      this.modal.open(this._ModalCrearDirectorio);
    } else {
      this.utilitariosService.MensajeToast('Debe seleccionar una carpeta.');
    }
  }
  CrearCarpetaConfirmacion() {
    if (this.form.valid) {
      this.mostrarCargando = true;
      let parametroConsulta = this.fb.group({
        'nombre': ['']
        ,'ruta': ['']
      });
      parametroConsulta.get('ruta').setValue(this.itemSeleccionadoDirectorio.ruta);
      parametroConsulta.get('nombre').setValue(this.form.get('directorio').value);
      this.datosServices.CrearDirectorio(parametroConsulta.value)
              .subscribe((resp: RespuestaGenerica) =>{
                this.mostrarCargando = false;
                if (resp.procesoExitoso == false) {
                  this.utilitariosService.MensajeToast(resp.mensaje);
                } else {
                  this.modal.closeAll();

                  let itemAdicionarDirectorio: SubirArchivos_Usuario_Directorios = new SubirArchivos_Usuario_Directorios();
                  itemAdicionarDirectorio.descripcion = this.form.get('directorio').value;
                  itemAdicionarDirectorio.descripcionRuta = `${this.itemSeleccionadoDirectorio.descripcionRuta}/${this.form.get('directorio').value}`;
                  itemAdicionarDirectorio.ruta = `${this.itemSeleccionadoDirectorio.ruta}\\${this.form.get('directorio').value}`;
                  itemAdicionarDirectorio.rutaPadre = this.itemSeleccionadoDirectorio.ruta;
                  itemAdicionarDirectorio.tieneSubDirectorios = false;
                  let itemDirectorioActualizar = this.datosServices.ListaDirectorios.filter(x => x.id == this.idFiltroSeleccionado)[0];
                  itemDirectorioActualizar.listaDirectorios.push(itemAdicionarDirectorio);

                  this.EstablecerHijos_Padre(itemAdicionarDirectorio.rutaPadre, itemDirectorioActualizar);
                  this.CambiarSeleccionRegistro(itemAdicionarDirectorio.ruta, itemDirectorioActualizar.id);
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  EliminarArchivosSeleccionados() {
    if (this.Checkeados.isEmpty() === false) {
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MensajeToast('Debe seleccionar al menos un registro.');
    }
  }
  DescargarArchivosSeleccionados() {
    if (this.Checkeados.isEmpty() === false) {
      this.mostrarCargando = true;
      let itemSeleccionado: SubirArchivos_Usuario_Archivos_Seleccionados = new SubirArchivos_Usuario_Archivos_Seleccionados();
      itemSeleccionado.itemDirectorio = this.itemSeleccionadoDirectorio;
      itemSeleccionado.listaArchivos = this.Checkeados.selected;
      let nombreArchivo: string = '';
      
      if (this.Checkeados.selected.length > 1) {
        nombreArchivo = `${itemSeleccionado.itemDirectorio.descripcion}_${this.utilitariosService.ObtenerFechaTextoConHora(new Date(), '', '_', '')}.zip`;
      } else {
        nombreArchivo = this.Checkeados.selected[0].nombreArchivo;
      }
      
      this.datosServices.DescargarArchivos(itemSeleccionado)
              .subscribe((resp: any) =>{
                this.mostrarCargando = false;
                let dataType = resp.type;
                let binaryData = [];
                binaryData.push(resp);
                let downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
                if (nombreArchivo)
                    downloadLink.setAttribute('download', nombreArchivo);
                document.body.appendChild(downloadLink);
                downloadLink.click();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
    } else {
      this.utilitariosService.MensajeToast('Debe seleccionar al menos un registro.');
    }
  }
  EstanTodosSeleccionados() 
  {
    let numSelected = this.Checkeados.selected.length;
    let numRows = 0;
    if (this.utilitariosService.VerificarContieneDatos(this.dataSourceArchivos)) {
      numRows = this.dataSourceArchivos.data.length;
    }
    
    return numRows > 0 && numSelected === numRows;
  }
  TodosSeleccionar() 
  {
    if (this.EstanTodosSeleccionados())
    {
      this.Checkeados.clear();
    }
    else
    {
      if (this.utilitariosService.VerificarContieneDatos(this.dataSourceArchivos)) {
        this.dataSourceArchivos.data.forEach(row => this.Checkeados.select(row));
      }
    }
  }
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.EstanTodosSeleccionados() ? 'select' : 'deselect'} all`;
    }
    return `${this.Checkeados.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }
  MarcarDesmarcarUno(selecciono: any, row?: any, _posicion?: number) {
    if (selecciono.checked) {
      this.Checkeados.toggle(row);
    } else {
      this.Checkeados.deselect(row);
    }
  }
  TituloOpcionMenu(): string {
    return this.menuService.ObtenerTituloOpcionComponente('SubirArchivosUsuarioComponent');
  }
}
